import { api } from './api';

const seen = new Set();
let queue = [];
let timer = null;

const flush = () => {
  timer = null;
  if (!queue.length) return;
  const ids = queue; queue = [];
  api.post('/track/impressions', { ids }).catch(() => {});
};

export const trackImpression = (id) => {
  if (!id || seen.has(id)) return;
  seen.add(id);
  queue.push(id);
  if (!timer) timer = setTimeout(flush, 1500);
};

let observer = null;
export const observeImpression = (el, id) => {
  if (!el || !id || typeof IntersectionObserver === 'undefined') return () => {};
  if (!observer) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting && e.intersectionRatio >= 0.5) { trackImpression(e.target.dataset.impressionId); observer.unobserve(e.target); } });
    }, { threshold: 0.5 });
  }
  el.dataset.impressionId = id;
  observer.observe(el);
  return () => observer && observer.unobserve(el);
};

const progress = {};
export const trackProgress = (catalogId, pageIndex, pages) => {
  if (!catalogId || !pages) return;
  const maxPage = Math.min(pages, pageIndex + 1);
  const cur = progress[catalogId] || { max: 0, timer: null };
  if (maxPage <= cur.max) return;
  cur.max = maxPage;
  progress[catalogId] = cur;
  clearTimeout(cur.timer);
  cur.timer = setTimeout(() => api.post(`/track/progress/${catalogId}`, { max_page: cur.max, pages }).catch(() => {}), 1200);
};
